<template>
    <div id="chatgpt-who-is-it" v-if="idxStep == 0">
        <div class="container">
            <div>
                <div class="col-left">
                    <div class="line-1">
                        <div v-html="$t('message.games.who_is_it.content_1')"></div>
                    </div>

                    <div class="line-2">
                        <div class="col-1">
                            <div v-html="$t('message.games.who_is_it.content_2')"></div>
                        </div>

                        <div class="col-2">
                            <button type="button" class="btn-lg" @click="runGame">
                                <span>{{ $t("message.games.who_is_it.btn_play") }}</span>
                            </button>
                        </div>
                    </div>

                    <div class="line-3"></div>

                    <div class="line-4">
                        <button type="button" class="btn-sm" @click="runGame">
                            <span>{{ $t("message.games.who_is_it.btn_play") }}</span>
                        </button>
                        <div v-html="$t('message.games.who_is_it.content_3')"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Transition>
        <div id="chatgpt-who-is-it-play" v-if="idxStep == 1">
            <div class="container">
                <div id="game">
                    <div>
                        <div>
                            <div class="intro intro-1">{{ $t("message.game_intro1") }}</div>
                            <div class="intro intro-2">{{ $t("message.game_intro2") }}</div>

                            <div>
                                <div>
                                    <div class="conversation" ref="conversation">
                                        <div v-for="(message, index) in messagesTchat" :key="index" :class="message.role">
                                            <IconHaikara color="red" v-if="message.role != 'user'" />
                                            <div>
                                                <div v-html="message.content"></div>
                                                <p v-if="message.helpImage">Veux-tu une image pour t'aider ?</p>
                                                <button type="button" @click="displayImage" v-if="message.helpImage" :disabled="statusImage">Oui</button>
                                            </div>
                                            <img src="@/assets/img/jeux/chatgpt_who_is_it/icone_user.png" alt="" v-if="message.role == 'user'" />
                                        </div>
                                    </div>

                                    <div>
                                        <input type="text" v-model="question" :disabled="!isGameStarted || isLoadGame || endGame" @keyup.enter="onEnterInputQuestion" ref="game-input" />

                                        <div class="btns">
                                            <button type="button" @click="sendQuestion(true)" class="btn-answer" :disabled="isLoadGame || !isGameStarted || endGame">
                                                <span>
                                                    <Spinner color="#fff" v-if="runAnswer" />
                                                    {{ $t("message.games.who_is_it.give_me_the_answer") }}
                                                </span>
                                            </button>
                                            <button type="button" @click="startGame" :disabled="isLoadGame && !isGameStarted" class="btn-restart">
                                                <span>
                                                    <Spinner color="#fff" v-if="isLoadGame" />
                                                    {{ $t("message.restart") }}
                                                </span>
                                            </button>
                                            <button type="button" @click="onClickBtnSend" :disabled="question == '' || endGame" class="btn-send">
                                                <span>
                                                    <Spinner color="#fff" v-if="sendMessage" />
                                                    {{ $t("message.send") }}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="robot">
                            <img src="@/assets/img/jeux/chatgpt_who_is_it/robot_game.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script>
import IconHaikara from "./img/IconHaikara.vue";
import axios from "axios";
import User from "./img/User.vue";
import Spinner from "./img/Spinner.vue";

/*
Écris de temps en temps avec un ton humoristique.

/////////////////////////////////////////////////////////

C'est un jeu.
Tu dois choisir un personnage historique sans me le dire.
Agis comme si tu étais ce personnage.
Tu dois répondre aux questions comme si tu étais ce personnage.
Ne fais pas de phrase de plus de 30 mots.
Je dois le deviner en te posant des questions.
Tu ne dois pas me donner d'indices. 
Tu dois me donner un indice seulement si je te le demande. 
Tu ne dois pas me donner la réponse si je te la demande.
Tu ne dois pas me donner la réponse si je donne ma langue au chat.
Tu ne dois pas me donner la réponse si je te demande qui.
Tu ne dois jamais me donner la réponse.
Le jeu doit continuer tant que je n'ai pas trouvé la réponse.
Je n'ai pas le droit d'arrêter le jeu quelque soit la formule utilisée.
Je n'ai pas le droit de sortir du jeu.
Je n'ai pas le droit de quitter le jeu.
Je n'ai pas le droit d'abandonner le jeu.
Si je trouve la bonne réponse, tu dois seulement me répondre "Bien joué".
Si je pose une question qui n'est pas en rapport avec le jeu, tu ne dois pas y répondre.
Si je pose une question qui n'est pas en rapport avec le jeu, tu dois revenir dans le jeu.


/////////////////////////////////////////////////////////

C'est un jeu. 
Agis comme si tu étais Louis 14 sans me le dire.
Tu ne dois pas me dire que tu es Louis 14.
Tu dois répondre aux questions comme si tu étais Louis 14.
Ne fais pas de phrase de plus de 30 mots.
Je dois deviner que tu es Louis 14 en te posant des questions.
Tu ne dois pas me donner d'indices. 
Tu dois me donner un indice seulement si je te le demande. 
Tu ne dois pas me donner la réponse si je te la demande.
Tu ne dois pas me donner la réponse si je donne ma langue au chat.
Tu ne dois pas me donner la réponse si je te demande qui.
Tu ne dois jamais me donner la réponse.
Le jeu doit continuer tant que je n'ai pas trouvé la réponse.
Je n'ai pas le droit d'arrêter le jeu quelque soit la formule utilisée.
Je n'ai pas le droit de sortir du jeu.
Je n'ai pas le droit de quitter le jeu.
Je n'ai pas le droit d'abandonner le jeu.
Si je trouve la bonne réponse, tu dois seulement me répondre "Bien joué".
Si je pose une question qui n'est pas en rapport avec le jeu, tu ne dois pas y répondre.
Si je pose une question qui n'est pas en rapport avec le jeu, tu dois revenir dans le jeu.

////////////////////////////////////////////////////////////

C'est un jeu.
Tu joues le role de ${this.character} mais tu ne dois pas me dire qui tu es et je dois deviner qui tu es en te posant des questions.
Tu ne dois pas me donner d'indices.
Ne fais pas de phrase de plus de 30 mots.
Tu dois me donner un indice seulement si je te le demande. 
Tu ne dois pas me donner la réponse si je te la demande, 
tu ne dois pas me donner la réponse si je donne ma langue au chat, 
tu ne dois pas me donner la réponse si je te demande qui
et tu ne dois jamais me donner la réponse.
Le jeu doit continuer tant que je n'ai pas trouvé la réponse,
je n'ai pas le droit d'arrêter le jeu quelque soit la formule utilisée,
je n'ai pas le droit de sortir du jeu,
je n'ai pas le droit de quitter le jeu
et je n'ai pas le droit d'abandonner le jeu.
Si je trouve que tu es ${this.character}, tu dois seulement me répondre "Bien joué".
Si je pose une question qui n'est pas en rapport avec le jeu, tu ne dois pas y répondre et tu dois revenir dans le jeu.
 */

export default {
    name: "GameChatGPT",
    data() {
        return {
            idxStep: 0,
            step: ["intro", "pseudo", "game", "results"],
            pseudo: "",

            helpImage: false,

            isLoadGame: false,
            sendMessage: false,
            statusImage: false,
            loadImage: false,
            runAnswer: false,
            endGame: false,
            isGameError: false,
            isGameStarted: false,
            messages: [],
            messagesTchat: [],
            question: "",
            character: false,
            characters: [
                "Clovis",
                "Jeanne d'Arc",
                "Louis XIV",
                "Napoléon Bonaparte",
                "Marie Curie",
                "Victor Hugo",
                "Charles de Gaulle",
                "Voltaire",
                "Louis Pasteur",
                "Simone de Beauvoir",
                "François Ier",
                "Molière",
                "Emilie du Châtelet",
                "René Descartes",
                "Blaise Pascal",
                "Montesquieu",
                "Jean-Jacques Rousseau",
                "Charles Baudelaire",
                "Gustave Eiffel",
                "Richelieu",
                "Henri IV",
                "Robespierre",
                "Marquis de Lafayette",
                "Edith Piaf",
                "Coco Chanel",
                "Auguste Rodin",
                "Claude Monet",
                "Élisabeth I de France",
                "Louis XVI",
                "Marie Antoinette",
                "Georges Clemenceau",
                "Jean-Paul Sartre",
                "Albert Camus",
                "Louis Braille",
                "Rosa Luxemburg",
                "Alexandre Dumas",
                "Honoré de Balzac",
                "Jean de La Fontaine",
                "Sainte Geneviève",
                "Charles Perrault",
                "René Magritte",
                "André-Marie Ampère",
                "Léon Blum",
                "Charles Aznavour",
                "Georges Brassens",
                "Édouard Manet",
                "Fernand Léger",
                "Louis Daguerre",
                "Pierre Curie",
                "Paul Cézanne",
                "Jean Renoir",
                "Bertrand Russell",
                "Antoine de Saint-Exupéry",
                "Gérard Depardieu",
                "Louis Jouvet",
                "Alfred Dreyfus",
                "Émile Zola",
                "Jules Verne",
                "Serge Gainsbourg",
                "François Truffaut",
                "Simone Signoret",
                "Georges Pompidou",
                "Alain Delon",
                "Charles Trenet",
                "Yves Montand",
                "Maurice Ravel",
                "Edgar Degas",
                "Françoise Sagan",
                "François Mitterrand",
                "Pierre-Simon Laplace",
                "Camille Saint-Saëns",
                "Jean Moulin",
                "Évariste Galois",
                "Marcel Proust",
                "Louis Blériot",
                "Marcel Marceau",
                "Louis Lumière",
                "Georges Méliès",
                "Catherine de Médicis",
                "Léonard de Vinci",
                "Charlotte Corday",
                "Marie de Médicis",
                "Jean-Baptiste Colbert",
                "Charles Fourier",
                "René Cassin",
                "Marie-Madeleine Fourcade",
                "Jacques Cartier",
                "François Rabelais",
                "Edgar Quinet",
                "Léon Gambetta",
                "Marcel Duchamp",
                "Théodore Géricault",
                "Lazare Carnot",
                "Alexandre Dumas fils",
                "Louis Bréguet",
                "François Mansart",
                "Jean Racine",
            ],
        };
    },
    components: {
        User,
        Spinner,
        IconHaikara,
    },
    methods: {
        runGame() {
            this.idxStep = 1;
            this.startGame();
        },
        onClickBtnSend() {
            this.sendQuestion();
        },
        onEnterInputQuestion() {
            this.sendQuestion();
        },
        displayImage() {
            let _this = this;

            this.loadImage = true;
            _this.statusImage = true;

            axios({
                method: "post",
                proxy: true,
                url: "./openapi_image.php",
                data: {
                    prompt: `Génère une peinture du portrait de ${_this.character}.`,
                },
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                },
            }).then(
                (response) => {
                    let messageDisplayImage = {};
                    messageDisplayImage.role = "assistant";
                    messageDisplayImage.content = `<img src="${response.data.message}" alt="" />`;
                    this.messagesTchat.push(messageDisplayImage);
                    _this.loadImage = false;

                    setTimeout(() => {
                        if (_this.$refs["conversation"]) _this.$refs["conversation"].scrollTo(0, _this.$refs["conversation"].scrollHeight);
                    }, 1000);
                },
                (error) => {
                    _this.loadImage = false;
                    console.log("error >> ", error);
                }
            );
        },
        startGame() {
            this.messages = [];
            this.messagesTchat = [];
            this.helpImage = false;
            this.statusImage = false;

            let _this = this;
            this.isLoadGame = true;

            this.question = "";

            let random = Math.floor(Math.random() * _this.characters.length);
            this.character = _this.characters[random];

            console.log(this.character);

            let messageUser = {};
            messageUser.role = "assistant";

            messageUser.content = `
                        C'est un jeu.
                        Les règles du jeu sont les suivantes:
                        - Tu es ${this.character}.
                        - Parle-moi comme si tu étais ${this.character}.
                        - Je dois deviner qui tu es.
                        - Tes réponses ne doivent jamais contenir le nom de ton personnage.
                        - Tu dois répondre en moins de 20 mots.
                        - Le jeu doit continuer tant que je n'ai pas trouvé la réponse.
                        - Si je devine ton identité, je gagne.
                        - Si je pose une question qui n'est pas en rapport avec le jeu, tu ne dois pas y répondre.
                        - Je n'ai pas le droit de quitter le jeu.
                        - Je n'ai pas le droit de changer de jeu.
                        - Tu dois me donner un indice seulement si je te le demande. 
                        - Tu ne dois pas me donner ton identité si je te la demande.
                        - Tu ne dois pas me donner ton identité si je donne ma langue au chat.
                        - Si je trouve ton identité, tu dois seulement me répondre "f45r4g4gre6eg4z".`;

            this.messages.push(messageUser);

            axios({
                method: "post",
                proxy: true,
                url: "./openapi.php",
                data: {
                    messages: _this.messages,
                },
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                },
            }).then(
                (response) => {
                    let messageAssistant = {};
                    messageAssistant.role = "assistant";
                    messageAssistant.content = response.data.message;

                    let messageTchat = {};
                    messageTchat.role = "assistant";
                    messageTchat.content = "D'accord, je suis prêt. Pose-moi ta première question.";

                    _this.messages.push(messageAssistant);
                    _this.messagesTchat.push(messageTchat);

                    _this.isLoadGame = false;
                    _this.isGameStarted = true;
                    _this.endGame = false;

                    setTimeout(() => {
                        if (_this.$refs["game-input"]) _this.$refs["game-input"].focus();
                    }, 200);
                },
                (error) => {
                    _this.isGameError = true;
                    _this.isLoadGame = false;
                }
            );
        },
        sendQuestion(answer) {
            let _this = this;

            let question = this.question;
            if (this.$refs["game-input"]) this.$refs["game-input"].focus();
            if (answer) this.runAnswer = true;
            else this.sendMessage = true;
            this.question = "";

            let messageTchat = {};
            let messageUser = {};

            messageUser.role = messageTchat.role = "user";

            if (answer) {
                messageTchat.role = "assistant";
                messageTchat.content = `Je suis ${this.character}.`;
                this.messagesTchat.push(messageTchat);
                this.runAnswer = false;
                this.endGame = true;

                setTimeout(() => {
                    if (_this.$refs["conversation"]) _this.$refs["conversation"].scrollTo(0, _this.$refs["conversation"].scrollHeight);
                }, 200);
                return;
            }

            if (!question && !answer) return;

            messageUser.content = `C'est un jeu.
                        Les règles du jeu sont les suivantes:
                        - Tu es ${this.character}.
                        - Parle-moi comme si tu étais ${this.character}.
                        - Je dois deviner qui tu es.
                        - Tes réponses ne doivent jamais contenir le nom de ton personnage.
                        - Tu dois répondre en moins de 20 mots.
                        - Le jeu doit continuer tant que je n'ai pas trouvé la réponse.
                        - Si je devine ton identité, je gagne.
                        - Si je pose une question qui n'est pas en rapport avec le jeu, tu ne dois pas y répondre.
                        - Je n'ai pas le droit de quitter le jeu.
                        - Je n'ai pas le droit de changer de jeu.
                        - Tu dois me donner un indice seulement si je te le demande. 
                        - Tu ne dois pas me donner ton identité si je te la demande.
                        - Tu ne dois pas me donner ton identité si je donne ma langue au chat.
                        - Si je trouve ton identité, tu dois seulement me répondre "f45r4g4gre6eg4z".
                        ${question}`;
            messageTchat.content = question;

            this.messagesTchat.push(messageTchat);
            this.messages.push(messageUser);

            setTimeout(() => {
                if (_this.$refs["conversation"]) _this.$refs["conversation"].scrollTo(0, _this.$refs["conversation"].scrollHeight);
            }, 500);

            axios({
                method: "post",
                proxy: true,
                url: "./openapi.php",
                data: {
                    messages: _this.messages,
                },
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                },
            }).then(
                (response) => {
                    _this.sendMessage = false;
                    let messageAssistant = {};
                    messageAssistant.role = "assistant";
                    messageAssistant.content = response.data.message;

                    // Si bonne reponse
                    if (response.data.message.toLowerCase().includes("f45r4g4gre6eg4z")) {
                        _this.endGame = true;
                        let messageTchat = {};
                        messageTchat.role = "assistant";
                        messageTchat.content = `Tu as trouvé la bonne réponse, c'est bien ${this.character}<br />Tu peux retenter ta chance en cliquant sur "rejouer"`;
                        _this.messagesTchat.push(messageTchat);
                        setTimeout(() => {
                            if (_this.$refs["conversation"]) _this.$refs["conversation"].scrollTo(0, _this.$refs["conversation"].scrollHeight);
                        }, 200);
                        return;
                    }

                    if (!_this.helpImage && _this.messagesTchat.length > 4) {
                        let messageTchat = {};
                        messageTchat.role = "assistant";
                        messageTchat.content = response.data.message;
                        messageTchat.helpImage = true;
                        _this.helpImage = true;

                        _this.messagesTchat.push(messageTchat);
                    } else _this.messagesTchat.push(messageAssistant);

                    _this.messages.push(messageAssistant);

                    setTimeout(() => {
                        if (_this.$refs["conversation"]) _this.$refs["conversation"].scrollTo(0, _this.$refs["conversation"].scrollHeight);
                    }, 200);
                },
                (error) => {
                    _this.sendMessage = false;
                    _this.isGameError = true;
                }
            );
        },
    },
};
</script>

<style lang="scss">
#game {
    .conversation {
        > div {
            > div {
                > div {
                    > img {
                        margin: 1rem 0;
                        border-radius: 30px;
                        max-width: 100%;
                        display: block;
                    }
                }
            }
        }

        button {
            cursor: pointer;
            font-family: M PLUS Code Latin, monospace;
            display: block;
            background: url("@/assets/img/jeux/chatgpt_who_is_it/btn_2.png");
            background-size: 100% 100%;
            padding: 0.5rem 0.5rem;
            box-sizing: border-box;
            color: #fff;
            text-transform: uppercase;
            box-shadow: 0 0 0;
            outline: 0;
            height: auto;
            position: relative;
            cursor: pointer;
            border-radius: 50px;
            border: 0;
            width: 100px;
            font-size: 1rem;

            &:first-child {
                margin-right: 0.3rem;
            }

            &:disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
        }
    }
}
</style>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=M+PLUS+Code+Latin:wght@100..700&display=swap");

@font-face {
    font-family: conthrax;
    src: url("@/assets/fonts/conthrax-sb.otf") format("opentype");
}

/** =======================================================
    INTRO
======================================================== */
#chatgpt-who-is-it {
    background: url("@/assets/img/jeux/chatgpt_who_is_it/bg.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    padding: 10% 0;
    border-radius: 30px;

    button {
        font-family: conthrax;
        color: #fff;
        text-transform: uppercase;
        font-size: 2.2rem;
        box-shadow: 0 0 0;
        border: 0;
        outline: 0;
        height: auto;
        width: auto;
        box-sizing: border-box;
        position: relative;
        cursor: pointer;
        border-radius: 50px;
        overflow: hidden;
        border: 3px solid #fff;
        background: transparent;
        padding: 4px;

        > span {
            display: block;
            background: url("@/assets/img/jeux/chatgpt_who_is_it/btn_2.png");
            background-size: 100% 100%;
            height: 100%;
            width: 100%;
            border-radius: 50px;
            overflow: hidden;
            padding: 1rem 2rem;
            box-sizing: border-box;
        }
    }

    .btn-sm {
        display: none;
    }

    .col-left {
        width: 50%;
        color: #fff;
    }

    > div > div {
        max-width: 1400px;
        margin: auto;
        display: flex;
        flex-flow: row nowrap;
    }

    .line-1 {
        font-family: conthrax;
        text-transform: uppercase;
        margin-bottom: 2rem;
        font-size: 2.2rem;
    }

    .line-2 {
        font-size: 1.4rem;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 2rem;

        .col-1 {
            flex: 1;
            padding-right: 1rem;
            box-sizing: border-box;
            font-family: "M PLUS Code Latin", monospace;
        }

        .col-2 {
            flex: 1;
            text-align: right;
        }
    }

    .line-3 {
        border-bottom: 3px solid #fff;
        margin-bottom: 2rem;
        width: 65%;
    }

    .line-4 {
        font-family: "M PLUS Code Latin", monospace;
        font-size: 1.4rem;
    }
}

.line-1 {
    font-size: 3rem;
}

@media (max-width: 1500px) {
}

@media (max-width: 1400px) {
    #chatgpt-who-is-it {
        button {
            font-size: 2rem;
            box-shadow: 0 0 0;
            padding: 3px;

            &:after {
                top: -9%;
                left: -2%;
                width: 102%;
                height: 108%;
            }
        }

        .col-left {
            width: 60%;
            color: #fff;
        }

        .line-1 {
            font-family: conthrax;
            text-transform: uppercase;
            margin-bottom: 2rem;
            font-size: 2.2rem;
        }

        .line-2 {
            font-size: 1.2rem;
            margin-bottom: 1.8rem;

            .col-1 {
                padding-right: 1rem;
            }

            .col-2 {
                text-align: left;
            }
        }

        .line-3 {
            margin-bottom: 2rem;
            width: 50%;
        }

        .line-4 {
            font-size: 1.2rem;
        }
    }

    .line-1 {
        font-size: 2.8rem;
    }
}

@media (max-width: 1200px) {
    #chatgpt-who-is-it {
        button {
            border: 2px solid #fff;
            font-size: 1.6rem;
            box-shadow: 0 0 0;
            padding: 2px;

            &:after {
                top: -9%;
                left: -2%;
                width: 102%;
                height: 108%;
            }
        }

        .col-left {
            width: 65%;
            color: #fff;
        }

        .line-1 {
            font-family: conthrax;
            text-transform: uppercase;
            margin-bottom: 1.8rem;
            font-size: 2rem;
        }

        .line-2 {
            font-size: 1rem;
            margin-bottom: 1.6rem;

            .col-1 {
                padding-right: 1rem;
            }

            .col-2 {
                text-align: left;
            }
        }

        .line-3 {
            margin-bottom: 1.8rem;
            width: 40%;
        }

        .line-4 {
            font-size: 1rem;
        }
    }

    .line-1 {
        font-size: 2.4rem;
    }
}

@media (max-width: 992px) {
    #chatgpt-who-is-it {
        background-size: cover;
        background-position: center;

        .btn-sm {
            display: block;
            margin-bottom: 1rem;
        }

        .btn-lg {
            display: none;
        }

        button {
            border: 1px solid #fff;
            font-size: 1.2rem;
            box-shadow: 0 0 0;

            > span {
                border-radius: 50px;
                padding: 0.5rem 1.8rem;
            }

            &:after {
                content: none;
            }
        }

        .col-left {
            width: 100%;
            color: #fff;
            position: relative;
            z-index: 1;
        }

        .line-1 {
            margin-bottom: 1.4rem;
            font-size: 1.4rem;
        }

        .line-2 {
            font-size: 1rem;
            margin-bottom: 1.2rem;

            .col-1 {
                padding-right: 1rem;
            }

            .col-2 {
                text-align: left;
            }
        }

        .line-3 {
            display: none;
        }

        .line-4 {
            font-size: 1rem;
        }
    }

    .line-1 {
        font-size: 2rem;
    }
}

@media (max-width: 768px) {
    .line-1 {
        font-size: 1.8rem;
    }
}

@media (max-width: 576px) {
}

/** =======================================================
    JEUX
======================================================== */
#chatgpt-who-is-it-play {
    background: url("@/assets/img/jeux/chatgpt_who_is_it/bg_game.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    min-height: 100%;
    display: flex;
    padding: 6rem 0;
    box-sizing: border-box;
    position: relative;
    border-radius: 30px;
}

#game {
    width: 100%;
    max-width: 1400px;
    position: relative;
    margin: 0 auto;
    display: flex;
    align-items: center;
    height: 100%;

    > div {
        width: 70%;
        position: relative;

        > div:not(.robot) {
            border: 1px solid #ddd;
            padding: 2rem;
            box-sizing: border-box;
            border-radius: 20px;
            background: rgba(255, 255, 255, 0.7);
            border: 2px solid #fff;
            width: 100%;
            z-index: 1;
            position: relative;
        }

        > .robot {
            position: absolute;
            top: -80px;
            right: -353px;
        }
    }

    .intro {
        font-size: 1.8rem;
        margin-bottom: 1rem;
        color: #9717a9;
        font-family: "M PLUS Code Latin", monospace;
        text-transform: uppercase;
        font-weight: 600;

        &.intro-2 {
            font-size: 1.2rem;
        }
    }

    .conversation {
        width: 100%;
        height: 400px;
        border-radius: 5px;
        margin-bottom: 1rem;
        overflow: auto;

        /*scrollbar-width: auto;
        scrollbar-color: #8f54a0 #ffffff;*/

        /* ===== Scrollbar CSS ===== */
        &::-webkit-scrollbar {
            width: 12px;
            height: 12px;
        }
        &::-webkit-scrollbar-button {
            width: 0px;
            height: 0px;
        }
        &::-webkit-scrollbar-thumb {
            background: #8f54a0;
            border: 0px solid #ffffff;
            border-radius: 50px;
        }
        &::-webkit-scrollbar-thumb:hover {
            background: #8f54a0;
        }
        &::-webkit-scrollbar-thumb:active {
            background: #8f54a0;
        }
        &::-webkit-scrollbar-track {
            background: transparent;
            border: 0px none transparent;
            border-radius: 50px;
        }
        &::-webkit-scrollbar-track:hover {
            background: transparent;
        }
        &::-webkit-scrollbar-track:active {
            background: transparent;
        }
        &::-webkit-scrollbar-corner {
            background: transparent;
        }

        > div {
            display: flex;
            flex-flow: row nowrap;
            box-sizing: border-box;
            margin: 1rem 0;
            padding: 0;
            align-items: center;

            > svg {
                width: 30px;
                margin-right: 1rem;
            }

            > img {
                height: 36px;
                width: auto;
                display: block;
                margin-left: 1rem;
            }

            > div {
                box-sizing: border-box;
                margin: 0;
                border-radius: 50px;
                padding: 1rem 2rem;
                max-width: 80%;
                font-family: "M PLUS Code Latin", monospace;
            }

            > span {
                margin-top: 0.5rem;
                margin-right: 0.5rem;
            }

            &.assistant {
                div {
                    background: red;
                    color: #fff;
                }
            }

            &.user {
                justify-content: flex-end;

                > span {
                    order: 1;
                }

                div {
                    background: #efefef;
                }
            }
        }
    }

    input {
        width: 100%;
        border: 2px solid #ddd;
        padding: 1rem;
        box-sizing: border-box;
        font-size: 1.2rem;
        outline: none;
        transition: all 0.4s;
        border-radius: 50px;
        background: transparent;

        &:focus {
            border-color: #0093ff;
        }
    }

    .btns {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 1rem;

        button {
            margin-left: 1rem;
            color: #fff;
            text-transform: uppercase;
            font-size: 1.2rem;
            box-shadow: 0 0 0;
            border: 0;
            outline: 0;
            height: auto;
            width: auto;
            box-sizing: border-box;
            position: relative;
            cursor: pointer;
            border-radius: 50px;
            overflow: hidden;
            border: 0;
            background: transparent;
            padding: 0;

            > span {
                font-family: "M PLUS Code Latin", monospace;
                display: block;
                background: url("@/assets/img/jeux/chatgpt_who_is_it/btn_2.png");
                background-size: 100% 100%;
                height: 100%;
                width: 100%;
                border-radius: 50px;
                overflow: hidden;
                padding: 1rem 2.5rem;
                box-sizing: border-box;
                position: relative;
                display: flex;
                align-items: center;

                svg {
                    width: 16px;
                    height: 16px;
                    position: absolute;
                    left: 14px;
                }
            }

            &:disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }

            &:last-child {
                > span {
                    background: url("@/assets/img/jeux/chatgpt_who_is_it/btn_1.png");
                }
            }
        }
    }
}

// Transition
.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}

@media (max-width: 1400px) {
    #chatgpt-who-is-it-play {
        width: 100%;
    }

    #game {
        width: 100%;
        margin: 0 auto 12rem;

        > div {
            width: 80%;

            > div:not(.robot) {
                padding: 2rem;
            }

            > .robot {
                top: -80px;
                right: -353px;
            }
        }

        .intro {
            font-size: 1.8rem;
            margin-bottom: 1rem;

            &.intro-2 {
                font-size: 1.2rem;
            }
        }

        .conversation {
            width: 100%;
            height: 400px;
            margin-bottom: 1rem;

            > div {
                margin: 1rem 0;

                > div {
                    padding: 1rem 2rem;
                    max-width: 70%;
                }

                > span {
                    margin-top: 0.5rem;
                    margin-right: 0.5rem;
                }

                button {
                    &:first-child {
                        margin-right: 0.3rem;
                    }
                }
            }
        }

        input {
            border: 2px solid #ddd;
            padding: 1rem;
            font-size: 1.2rem;
        }

        .btns {
            margin-top: 1rem;

            button {
                font-size: 1.2rem;
                height: 50px;
            }
        }
    }
}

@media (max-width: 1200px) {
    #chatgpt-who-is-it-play {
        width: 100%;
    }

    #game {
        width: 100%;
        margin: 0 auto 12rem;

        > div {
            width: 100%;

            > div:not(.robot) {
                padding: 2rem;
            }

            > .robot {
                top: -80px;
                right: 0;
            }
        }

        .intro {
            font-size: 1.8rem;
            margin-bottom: 1rem;

            &.intro-2 {
                font-size: 1.2rem;
            }
        }

        .conversation {
            width: 100%;
            height: 400px;
            margin-bottom: 1rem;

            > div {
                margin: 1rem 0;

                > div {
                    padding: 1rem 2rem;
                    max-width: 70%;
                }

                > span {
                    margin-top: 0.5rem;
                    margin-right: 0.5rem;
                }

                button {
                    &:first-child {
                        margin-right: 0.3rem;
                    }
                }
            }
        }

        input {
            border: 2px solid #ddd;
            padding: 1rem;
            font-size: 1.2rem;
        }

        .btns {
            margin-top: 1rem;

            button {
                font-size: 1.2rem;
                height: 50px;
            }
        }
    }
}

@media (max-width: 992px) {
}

@media (max-width: 768px) {
    #chatgpt-who-is-it-play {
        width: 100%;
    }

    #game {
        width: 100%;
        margin: 0 auto 12rem;

        > div {
            width: 100%;

            > div:not(.robot) {
                padding: 2rem;
            }

            > .robot {
                top: -80px;
                right: 0;
            }
        }

        .intro {
            font-size: 1.4rem;
            margin-bottom: 1rem;

            &.intro-2 {
                font-size: 1rem;
            }
        }

        .conversation {
            width: 100%;
            height: 400px;
            margin-bottom: 1rem;

            > div {
                margin: 1rem 0;

                > div {
                    padding: 1rem 2rem;
                    max-width: 85%;
                }

                > span {
                    margin-top: 0.5rem;
                    margin-right: 0.5rem;
                }

                button {
                    &:first-child {
                        margin-right: 0.3rem;
                    }
                }
            }
        }

        input {
            border: 2px solid #ddd;
            padding: 1rem;
            font-size: 1.2rem;
        }

        .btns {
            margin-top: 1rem;
            display: flex;
            flex-flow: column;

            button {
                font-size: 1.2rem;
                width: 100%;
                height: 50px;
                margin: 0 0 1rem 0;
            }
        }
    }
}

@media (max-width: 576px) {
}
</style>
